import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-left\"><defs><style></style></defs><path d=\"M762.231 894.771L379.461 512l382.77-382.771V11.537L261.77 512l500.462 500.463z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol